'use client'
import { useState } from "react";
import Search from "../../header-common/search/Search";
import SvgSearchIcon from "../../header-common/search/search-helpers/search-icons/SvgSearchIcon";

const SearchPart = () => {
  const [viewSearch, setViewSearch] = useState(false);
  return viewSearch ? (
    <Search onBlur={() => setViewSearch(false)} PC />
  ) : (
    <SvgSearchIcon onClick={() => setViewSearch(true)} />
  );
};

export default SearchPart;
